import React, { Component } from 'react';
import SearchBar from './SearchBar';

import queryString from 'query-string';
import { push } from 'react-router-redux';
import { withRouter } from '../containers/WithRouter';

/*
 Search bar with defined search behavior
*/
class GeneralSearchBar extends Component {
  searchBehavior(searchBar, input) {
    const trimmedQuery = input.value.trim();
    //validate that the query is a non-null string.
    if (trimmedQuery) {
      const { dispatch } = searchBar.props;
      const stringified = queryString.stringify({ query: trimmedQuery });
      searchBar.setState({ query: trimmedQuery });
      dispatch(push(`/search?${stringified}`));
    }
  }

  render() {
    return (
      <SearchBar query={this.props.query} handleSearch={this.searchBehavior} />
    );
  }
}

export default withRouter(GeneralSearchBar);
